import _replace from "ramda/es/replace";
import _path from "ramda/es/path";
import _compose from "ramda/es/compose";
import s3Event from './s3Event';

var rawKey = _compose(_path(['object', 'key']), s3Event);

export default _compose(decodeURIComponent, _replace(/\+/g, ''), rawKey);